import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaGlobe,
  FaShieldAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import logoCiddec from "../magenes/LogoMexicoGente.png";

const guinda = "#611232";

export default function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterLogo
            style={{ display: "flex", alignItems: "center", gap: "1rem" }}
          >
            <LogoFooter src={logoCiddec} alt="CIDDEC Logo" />
            CENAC
          </FooterLogo>
          <FooterText>
            Programa nacional dedicado a la prevención, asesoría y recuperación
            patrimonial de víctimas de fraude digital en México.
          </FooterText>
          <SocialLinks>
            <SocialIcon href="https://www.facebook.com/profile.php?id=61564777964052&mibextid=wwXIfr&rdid=IXqjYtv4ZU2rEs6O&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19qJN2YQyA%2F%3Fmibextid%3DwwXIfr">
              <FaFacebook />
            </SocialIcon>
            <SocialIcon href="#">
              <FaTwitter />
            </SocialIcon>
            <SocialIcon href="#">
              <FaInstagram />
            </SocialIcon>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Contacto Directo</FooterTitle>
          <ContactLink href="tel:+56 5667 4253">
            <FaPhoneAlt /> 56 5667 4253
          </ContactLink>
          <ContactLink href="mailto:ciddecadministracion@gmail.com">
            <FaEnvelope /> ciddecadministracion@gmail.com
          </ContactLink>
          <ContactLink >
            <FaGlobe /> Bosque de alisos 45, Cuajimalpa de Morelos, 05120, cdmx., Cuajimalpa, Mexico, 05120
          </ContactLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Instituciones Aliadas</FooterTitle>
          <AllyList>
            <li>PROFECO</li>
            <li>CONDUSEF</li>
            <li>CNBV</li>
            <li>Guardia Nacional (Ciberseguridad)</li>
          </AllyList>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Respaldo Legal</FooterTitle>
          <Badge>
            <FaShieldAlt /> 100% Gratuito
          </Badge>
          <Badge>
            <FaShieldAlt /> Oficial y Seguro
          </Badge>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <p>
          &copy; {new Date().getFullYear()} CIDDEC - Campaña Integral de
          Denuncia Ciudadana. Todos los derechos reservados. |{" "}
          <a href="#">Aviso de Privacidad</a> |{" "}
          <AdminLink to="/admin">Portal Administrativo</AdminLink>
        </p>
      </FooterBottom>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer`
  background: #1a1a1a;
  color: #ffffff;
  padding: 5rem clamp(1rem, 5vw, 4rem) 2rem; // Alineado con el Header
  font-family: "Inter", sans-serif;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 3rem;
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const LogoFooter = styled.img`
  height: 120px;
  width: 120px;
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const FooterLogo = styled.h2`
  font-size: 1.8rem; // Nombre más grande
  font-weight: 900;
  color: white;
  margin: 0;
  letter-spacing: -1px;
`;

const FooterText = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
  margin: 0;
`;

const FooterTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialIcon = styled.a`
  color: white;
  font-size: 1.2rem;
  opacity: 0.6;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 1;
  }
`;

const ContactLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.9rem;
  &:hover {
    color: white;
  }
  svg {
    color: #8b1d47;
  }
`;

const AllyList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  svg {
    color: #137333;
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 2rem;
  text-align: center;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.4);
  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const AdminLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  opacity: 0.1;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
`;
